import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';


@Component({
    selector: 'app-emoji',
    templateUrl: './app-emoji.component.html',
})
export class AppEmoji {
    
}


// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/customClass/app-emoji/app-emoji.component.ts